export const pageTypeMap = {
    HOME: 'home',
    ANALYTICS: 'analytics',
    GLOSSARY: 'glossary',
    DATASET: 'dataset',
    DOMAINS: 'domains',
    PERMISSIONS: 'permissions',
    INGESTION: 'ingestion',
    DATA_PRODUCTS: 'products',
    DASHBOARD: 'edcDashboard',
    CHART: 'chart',
    PIPELINE: 'pipeline',
    ML_MODEL: 'mlModel',
    ML_MODEL_GROUP: 'mlModelGroup',
    FEATURE_TABLE: 'featureTable',
    GLOSSARY_NODE: 'glossaryNode',
    GLOSSARY_TERM: 'glossaryTerm',
    EDC_PERMISSIONS: 'edc-permissions',
    EDC_INGESTION: 'edc-ingestion',
};

export type PageType = typeof pageTypeMap[keyof typeof pageTypeMap];

export const pageTypePatterns = [
    { type: pageTypeMap.ANALYTICS, patterns: ['analytics', '/analytics'] },
    { type: pageTypeMap.GLOSSARY, patterns: ['glossary', '/glossary'] },
    { type: pageTypeMap.DATASET, patterns: ['dataset', '/dataset'] },
    { type: pageTypeMap.DOMAINS, patterns: ['domains', 'domain', '/domains'] },
    { type: pageTypeMap.PERMISSIONS, patterns: ['permissions', 'policies', '/permissions', '/settings'] },
    { type: pageTypeMap.INGESTION, patterns: ['manage ingestion', 'ingestion', '/ingestion'] },
    // enable when we have a data product in the sidebar nav-items
    // {
    //     type: pageTypeMap.DATA_PRODUCTS,
    //     patterns: ['data products', 'data product', '/browse/dataproduct', '/dataproduct'],
    // },
];

export const helpCenterPageTypePatterns = [
    {
        type: pageTypeMap.DATA_PRODUCTS,
        patterns: ['data products', 'data product', '/browse/dataproduct', '/dataproduct'],
    },
    { type: pageTypeMap.DASHBOARD, patterns: ['dashboard', '/dashboard'] },
    { type: pageTypeMap.CHART, patterns: ['chart', '/chart'] },
    { type: pageTypeMap.PIPELINE, patterns: ['pipelines', '/pipelines'] },
    { type: pageTypeMap.ML_MODEL, patterns: ['ml models', '/mlModels'] },
    { type: pageTypeMap.EDC_PERMISSIONS, patterns: ['permissions', 'policies', '/permissions', '/settings'] },
    { type: pageTypeMap.EDC_INGESTION, patterns: ['manage ingestion', 'ingestion', '/ingestion'] },
    // { type: pageTypeMap.ML_MODEL_GROUP, patterns: ['ml model groups', '/mlModelGroup'] },
    // { type: pageTypeMap.FEATURE_TABLE, patterns: ['feature tables', '/featureTables'] },
    ...pageTypePatterns,
    {
        type: '',
        patterns: ['home', '/'],
    },
];
